"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperImage = exports.PhotoImage = exports.EditIcon = exports.BannerLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _edit = _interopRequireDefault(require("../../assets/png/edit.png"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var WrapperImage = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-height: 291px;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  @media screen and (max-width: 420px) {\n    min-height: 107px;\n  }\n"])));
exports.WrapperImage = WrapperImage;
var PhotoImage = _styledComponents.default.img.attrs({
  alt: 'photo'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  max-height: 291px;\n  width: 100%;\n  position: relative;\n  @media screen and (max-width: 420px) {\n    min-height: 107px;\n  }\n"])), function (_ref) {
  var photoUrl = _ref.photoUrl;
  return photoUrl;
});
exports.PhotoImage = PhotoImage;
var EditIcon = _styledComponents.default.img.attrs({
  src: _edit.default,
  alt: 'edit',
  role: 'button'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  width: 25px;\n  height: 25px;\n"])));
exports.EditIcon = EditIcon;
var BannerLabel = _styledComponents.default.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  font-size: 40px;\n  color: #80808091;\n  z-index: 2;\n  letter-spacing: 0.2px;\n  font-family: 'Brandon Grotesque', Arial, sans-serif;\n"])));
exports.BannerLabel = BannerLabel;